var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main Ssdt"},[_c('Titledx',{attrs:{"text":"部门事项图谱"}}),_c('div',{staticClass:"cont"},[_c('three')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }